import { computed } from "vue";
import TABS from "../models/tabs.js";

export function useCallTabs(currentTab) {
	const isCameraTab = computed(() => currentTab.value === TABS.CAMERA);
	const isEditingTab = computed(() => currentTab.value === TABS.EDITING);
	const isThumbnailsTab = computed(() => currentTab.value === TABS.THUMBNAILS);

	return {
		isCameraTab,
		isEditingTab,
		isThumbnailsTab,
	};
}
